<template>
  <div class="Trio-wrapper">
    <funnel-header></funnel-header>
    <funnel-from v-if="step == 1"></funnel-from>
    <congratulations v-if="step == 2"></congratulations>
  </div>
</template>

<script>
import funnelHeader from "./funnelHeader.vue";
import { Store } from "../store/index.js";
import funnelFrom from "./funnelForm.vue";
import congratulations from "./Congratulations.vue";

export default {
  name: "funnelMortgage",
  components: {
    funnelHeader,
    funnelFrom,
    congratulations,
  },
  created() {
    Store.commit("ui/SET_STEP", 1);
  },
  computed: {
    step() {
      return Store.getters["ui/step"];
    },
  },
};
</script>